<template>

  <v-toolbar color="#E3F2FD" style="border-radius: 10px;">
    <v-toolbar-title>
      <span class="text--secondary text-subtitle-1">{{ title }}</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div>
      <v-btn class="rounded-lg mr-2" fab small v-if="okButton" @click="$emit('ok')" color="primary">
        <v-icon>mdi-check</v-icon>&nbsp;Ок
      </v-btn>

      <v-btn class="rounded-lg mr-2" fab small v-if="createButton" @click="$emit('create')" color="primary">
        <v-icon>mdi-playlist-plus</v-icon><span v-if="$vuetify.breakpoint.mdAndUp">&nbsp;Новый</span>
      </v-btn>

      <v-btn class="rounded-lg mr-2" fab small v-if="photoButton" @click="$emit('photo')" color="cyan" dark>
        <v-icon>mdi-camera</v-icon>
      </v-btn>

      <v-btn class="rounded-lg mr-2" fab small v-if="coordsButton" @click="$emit('coords')" color="cyan" dark>
        <v-icon>mdi-map-marker-radius-outline</v-icon>
      </v-btn>

      <v-btn class="rounded-lg mr-2" fab small v-if="loadButton" @click="$emit('load')" :disabled="!saveEnabled"
        color="primary">
        <span>Загрузить</span>
      </v-btn>

      <v-menu v-if="showMenu" :offset-y=true>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="rounded-lg mr-2" fab small color="primary" v-bind="attrs" v-on="on" dark>
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>

          <!-- <v-list-item v-if="photoButton" :key="14" @click="$emit('photo')" link align="left">
              <v-list-item-title>
                <v-icon>mdi-camera</v-icon>&nbsp;Фотография
              </v-list-item-title>
            </v-list-item> -->

          <v-list-item v-if="voiceRecordButton" :key="15" @click="$emit('voiceRecord')" link align="left">
            <v-list-item-title>
              <v-icon>mdi-microphone</v-icon>&nbsp;Аудиозапись
            </v-list-item-title>
          </v-list-item>

          <v-list-item v-if="fileButton" :key="7" @click="$emit('file')" link align="left">
            <v-list-item-title>
              <v-icon>mdi-paperclip</v-icon>&nbsp;Файлы
            </v-list-item-title>
          </v-list-item>

          <v-divider v-if="deleteButton" />
          <v-list-item v-if="deleteButton" :key="100" @click="$emit('delete')" link align="left">
            <v-list-item-title>
              <v-icon color="red">mdi-trash-can-outline</v-icon>&nbsp;<span style="color: red">Удалить</span>
            </v-list-item-title>
          </v-list-item>

        </v-list>
      </v-menu>

      <v-btn class="rounded-lg" fab small v-if="saveButton" @click="$emit('save')" :disabled="!saveEnabled"
        color="primary">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>

      <v-btn class="rounded-lg mr-2" v-if="updateButton" @click="$emit('update')" color="primary">
        <v-icon>mdi-reload</v-icon><span v-if="$vuetify.breakpoint.mdAndUp">&nbsp;Обновить</span>
      </v-btn>

      <v-btn class="rounded-lg mr-2" v-if="deleteSelectedButton" @click="$emit('deleteSelected')" color="red" dark>
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>

      <v-btn class="rounded-lg mr-2" v-if="cancelButton" @click="$emit('cancel')" color="blue-grey lighten-1" dark>
        Отмена
      </v-btn>

      <v-btn class="rounded-lg" v-if="closeButton" @click="$emit('close')" color="blue-grey lighten-1" dark>
        Закр.
      </v-btn>

    </div>


  </v-toolbar>




</template>

<script>
export default {
  name: "commandPanel",

  props: {
    title: "",

    photoButton:          false,
    coordsButton:         false,
    
    saveEnabled:          false,

    selectAllButton:      false,
    unselectAllButton:    false,

    okButton:             false,
    cancelButton:         false,

    createButton:         false,
    createFolderButton:   false,
    saveButton:           false,
    saveCloseButton:      false,
    updateButton:         false,

    // Меню
    fileButton:           false,
    loadButton:           false,
    deleteButton:         false,
    voiceRecordButton:    false,
    //

    deleteSelectedButton: false,
    closeButton:          false,
  },

  data() {
    return {
      showMenu:
           this.fileButton
        || this.deleteButton
        || this.voiceRecordButton
    }
  },

}
</script>

<style scoped>
 .v-toolbar {
  border-radius: 10px;
  
}
</style>
